import { MSDropdown } from '../../common/dropdown/index.js';
import { makeid } from '../../common/utils/idgen.js';
import { UiFloatModal } from '../../common/modal/index'
import i18next from "i18next";


const closeIcon = `
<svg width="10" height="10" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.75 0.75L5.25 5.25M5.25 0.75L0.75 5.25" stroke="#6E7079"/>
</svg>
`

const CreateGrouTemplate = () => `
    <style>
        @import "controls/chartcolumn/groups/groups.css";
    </style>
    <div class="create-group-content">
        <div class="input-container" slot="children">
            <input type="text" placeholder='${i18next.t("chartgroup_group_name")}' />
            <div id="error-groups" class="error-groups"></div>
        </div>
        <div class="groups-buttons-wrap">
                <div id="groups-btn-apply" class="groups-btn">${i18next.t("apply")}</div>
                <div id="groups-btn-cancel" class="groups-btn">${i18next.t("chartgroup_cancel")}</div>
        </div>
    </div>
`
const createGroup = (canCreate) => `
        <div slot="childrens" class="creategroup-wrap">
            ${canCreate ? OpenCreateGroupBtn : ''}
        </div>
`;

const OpenCreateGroupBtn = () => `<div id="create-group-btn" class="create-btn create-group-btn">${i18next.t("chartgroup_create_group")}</div>`

const template = (name = i18next.t("chartgroup_standart_group"), canCreate = true) => `
    <style>
        @import "controls/chartcolumn/groups/groups.css";
    </style>
    <div id="chart-group">
        <ui-dropdown value="" id="nav-group">
            ${createGroup(canCreate)}
            <div slot="label" id="group-dropdown-label" class="group-dropdown-label">
                <div id="group-label">${name}</div>
                <div class="icon-arrow"></div>
            </div>
        </ui-dropdown>
    </div>
`;

/**
 * @class ChartGroups
 * @classdesc Группы столбчатой диаграммы
 * */
export class ChartGroups {

    constructor(container, root) {
        this._values = []
        this.container = container
        this.root = root
        this.state = this.root.state
        const defaultGroup = this.state.groups.find(item => item.id === 'default')
        this.container.innerHTML = template(defaultGroup.name, false)
        this.root.checkComponent('ui-dropdown', MSDropdown)
        this.labelElem = this.container.querySelector('#group-label')
        this.initOpenCreateBtn()
        this.initDropdown()
    }

    initOpenCreateBtn() {
        if (this.root.pmPenGroupsCreate) {
            this.ceateGroupElem = this.container.querySelector('.creategroup-wrap')
            this.ceateGroupElem.innerHTML = OpenCreateGroupBtn()
            this.openCreateGroupBtn = this.container.querySelector('#create-group-btn')
            this.openCreateGroupBtn.addEventListener('click', this.createGroupTemplate.bind(this))
        } else {
            this.ceateGroupElem = this.container.querySelector('.creategroup-wrap')
            this.ceateGroupElem.innerHTML = ''
        }
    }

    initDropdown() {
        this.dropdown = this.root.shadowRoot.querySelector('#nav-group')
        this.dropdown.cssElem.innerHTML += '@import "controls/chartcolumn/groups/groups.css";'
        this.dropdown.onClick = this.root.changeGroupHandler.bind(this.root)
        this.dropdown.onOpenHandler = this.dropdown.onCloseHandler = this.onToggleDropdown.bind(this)
        this.root.shadowRoot.addEventListener('click', this.autoClose.bind(this))
        this.values = this.state.groups
    }

    createGroupTemplate() {
        if (!this.pensModal) {
            this.pensModal = new UiFloatModal(CreateGrouTemplate())
            if(!this.root.parentHasPopup) this.pensModal.root.style.zIndex = 10000100
            this.errorBlock = this.pensModal.modalComponent.querySelector('#error-groups')
            this.popupInput = this.pensModal.modalComponent.querySelector('input')
            this.applyBtn = this.pensModal.modalComponent.querySelector('#groups-btn-apply')
            this.cancelBtn = this.pensModal.modalComponent.querySelector('#groups-btn-cancel')
            this.modalCloseBtn = this.pensModal.modalComponent.querySelector('#modal-close')
            this.applyBtn.addEventListener('click', (e) => this.createGroup.bind(this)())
            this.cancelBtn.addEventListener('click', (e) => this.onClose.bind(this)())
            // this.modalCloseBtn.addEventListener('click', (e) => this.onClose.bind(this)())
            this.pensModal.modalComponent.label = i18next.t("chartgroup_group_name");
        }
        this.pensModal.modalComponent.toggle()
    }

    createGroup(e) {
        const inputValue = this.popupInput.value
        if (!inputValue || this.state.groups.find(item => item.name === inputValue)) {
            const text = !inputValue ? `${i18next.t("chartgroup_name_cannot_be_empty")}` : `${i18next.t("chartgroup_group_name_exists")}`
            this.errorBlock.innerHTML = text
            return
        }
        const id = makeid(10)
        const elem = this.createGroupComponent(id, inputValue)
        const newGroup = { id, name: inputValue, selected: [], active: true, component: elem }
        this.values.push(newGroup)
        this.root.initSelectTree(newGroup, true)
        this.onClose()
    }

    onGroupDelete(e) {
        e.stopPropagation()
        const li = e.target.closest('li')
        const Id = li.getAttribute('Id')
        const group = this.values.find(g => g.id === Id)
        if (this.value === group.id) {
            const selectedGroup = this.state.groups.find(g => g.id === 'default')
            this.state.selectedSources = selectedGroup.selected.map(g => g.source)
            this.value = 'default'
        }
        this.state.groups = this.state.groups.filter((g) => g.id !== group.id)
        this.values = this.state.groups
        this.saveState()
    }

    onClose(e) {
        this.popupInput.value = ''
        this.errorBlock.innerHTML = ''
        this.pensModal.modalComponent.close()
    }

    onToggleDropdown() {
        if (this.dropdown.active) {
            this.dropdown.rootElem.style.marginTop = -5
            this.dropdown.rootElem.style.marginLeft = -5
        } else {
            this.dropdown.rootElem.style.marginTop = 0
            this.dropdown.rootElem.style.marginLeft = 0
        }
    }

    autoClose(e) {
        if (!this.dropdown?.active) return
        const target = e.target
        if (!target.shadowRoot && !this.dropdown.contains(target)) this.dropdown.active = false
    }

    saveState() {
        if (!this.state.saveStateFlag) return
        const groupsForSave = this.state.groups.filter(p => p.id !== 'default')
            .map(({ component, ...rest }) => rest)
        const activeIdForSave = this.state.selectedGroup
        this.root.saveItemState({ groups: groupsForSave, activeGroupId: activeIdForSave })
    }

    createGroupComponent(id, name) {
        const elem = document.createElement('div')
        const deleteBtn = document.createElement('div')
        deleteBtn.setAttribute('Id', id)
        deleteBtn.addEventListener('click', this.onGroupDelete.bind(this))
        deleteBtn.innerHTML = closeIcon
        elem.textContent = name
        elem.appendChild(deleteBtn)
        return elem
    }

    get values() {
        return this._values
    }

    set values(v) {
        if (!v.length) return this._values
        this._values = v
        this.dropdown.values = this._values
        this.dropdown.createList()
    }

    get value() {
        return this.state.selectedGroup
    }

    set value(v) {
        this.state.selectedGroup = v
        const elem = this.state.groups.find(elem => elem.id === v)
        this.labelElem.innerHTML = elem.name
        this.root.updateGroupState()
    }

    get group() {
        if (!this.state.selectedGroup) return null
        const elem = this.state.groups.find(elem => elem.id === this.state.selectedGroup)
        if (!elem) return null
        return elem
    }
}